export const currencies = [
  { label: "USD", value: "usd" },
  { label: "EUR", value: "eur" },
  { label: "JPY", value: "jpy" },
  { label: "IDR", value: "idr" },
  { label: "AUD", value: "aud" },
  { label: "CAD", value: "cad" },
  { label: "CHF", value: "chf" },
  { label: "CNY", value: "cny" },
  { label: "SEK", value: "sek" },
  { label: "NZD", value: "nzd" },
  // Add more currencies as needed
];

export const currencySymbols: { [key: string]: string } = {
  usd: "$",
  eur: "€",
  gbp: "£",
  jpy: "¥",
  aud: "A$",
  cad: "C$",
  chf: "CHF",
  cny: "¥",
  sek: "kr",
  nzd: "NZ$",
  mxn: "MX$",
  sgd: "S$",
  hkd: "HK$",
  nok: "kr",
  krw: "₩",
  try: "₺",
  rub: "₽",
  inr: "₹",
  brl: "R$",
  zar: "R",
  idr: "Rp",
  // Add more currencies as needed
};

export const getCurrencySymbol = (currencyCode: string): string => {
  return currencySymbols[currencyCode.toLowerCase()] || currencyCode;
};
